import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getPreviewCollaborationSettings } from 'zoomforth_codesbane_viewer/reducers/index.js';
import hasEqualProps from 'zoomforth_zfutils/has_equal_props.js';
import Iframe from 'zoomforth_component_lib/iframe.jsx';
import SkipLinkForElement from 'zoomforth_codesbane_viewer/component_lib/skip_link_for_element.jsx';
import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

/*************************************************************************************************/
/*** PROPS ***************************************************************************************/
/*************************************************************************************************/

const PROP_TYPES = {
  iframeSrc: PropTypes.string.isRequired
};

const mapStateToProps = (reduxState) => {
  const previewCollaborationSettings = getPreviewCollaborationSettings(reduxState);
  const isPreviewCollaborationEnabled = !!previewCollaborationSettings.isEnabled;

  const iframeWrapperProps = {};
  if(isPreviewCollaborationEnabled){
    iframeWrapperProps['data-velt-iframe-container'] = true;
  }
  
  return {
    iframeWrapperProps
  };
};

const mapDispatchToProps = () => { return {}; };

/*************************************************************************************************/
/*** LEGACY **************************************************************************************/
/*************************************************************************************************/

class GridTileInnerTypeIframe_ViewerVersion1 extends Component {

  shouldComponentUpdate(nextProps) {
    // we only want to rerender this tile if the URL actually changes,
    // otherwise it will rerender in the editor when you click off it.
    return !hasEqualProps(this.props, nextProps, ['iframeSrc' ]);
  }

  render() {
    return (
      <div className="tile-iframe-wrapper" {...this.props.iframeWrapperProps}>
        <Iframe
          src={this.props.iframeSrc}
          title={this.props.iframeTitle}
          className="tile-iframe"
          frameBorder="0"
          allowFullScreen={true} 
        />
      </div>
    );
  }

}

class GridTileInnerTypeIframe_ViewerVersion2 extends Component {

  shouldComponentUpdate(nextProps) {
    // we only want to rerender this tile if the URL actually changes,
    // otherwise it will rerender in the editor when you click off it.
    return !hasEqualProps(this.props, nextProps, ['iframeSrc' ]);
  }

  render() {
    return (
      <div className="tile-iframe-wrapper" {...this.props.iframeWrapperProps}>
        <SkipLinkForElement skipLinkText="Skip iframe">
          <Iframe
            src={this.props.iframeSrc}
            title={this.props.iframeTitle}
            className="tile-iframe"
            frameBorder="0"
            allowFullScreen={true} 
          />
        </SkipLinkForElement>
      </div>
    );
  }

}

const GridTileInnerTypeIframe = (props)=> (
  <SiteViewerVersionComponentSelector>
    <GridTileInnerTypeIframe_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <GridTileInnerTypeIframe_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

GridTileInnerTypeIframe.propTypes = PROP_TYPES;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GridTileInnerTypeIframe);
